import { getPdfViewerToolbarSelectableOptions } from '../../PdfViewerToolbar.utils'

import {
  PDF_VIEWER_FIT_MODE_OPTIONS,
  PDF_VIEWER_ZOOM_PRESETS,
  PDF_VIEWER_ZOOM_SECTION_ID,
} from './PdfViewerToolbarZoomTool.constants'

export function formatPdfViewerScale(scale) {
  return `${Math.round((scale ?? 1) * 100)}%`
}

export function getPdfViewerZoomSections({ scaleValue, onChangeScaleValue }) {
  return [
    {
      id: PDF_VIEWER_ZOOM_SECTION_ID.fitMode,
      options: getPdfViewerToolbarSelectableOptions({
        options: PDF_VIEWER_FIT_MODE_OPTIONS,
        selectedValue: scaleValue,
        onSelect: onChangeScaleValue,
      }),
    },
    {
      id: PDF_VIEWER_ZOOM_SECTION_ID.zoomPresets,
      options: PDF_VIEWER_ZOOM_PRESETS.map(preset => ({
        isSelected: scaleValue === preset,
        qaName: `pdfViewerZoom${Math.round(preset * 100)}`,
        title: formatPdfViewerScale(preset),
        value: preset,
        onSelect: onChangeScaleValue,
      })),
    },
  ]
}
